import * as Yup from 'yup'
import i18n from '../../i18n'
import { VALIDATION, VALIDATION_MESSAGES } from '../../utils/translation-constants'
import config from 'custom/config/environment'
// eslint-disable-next-line import/prefer-default-export
export const QuickPaySchema = Yup.object().shape({
  sourceAccount: Yup.string(),
  sourceBranch: Yup.string(),
  sourceCurrency: Yup.string(),
  accountType: Yup.string(), //.required('Please Select a Request Type'),
  accountType: Yup.string().required(i18n.t(VALIDATION_MESSAGES.TRANSFER_TYPE)),
  // transferType: Yup.string().required('Please Select Transfer Type'),
  bankName: Yup.string().when('accountType', {
    // .when('transferType', {
    is: 'IAT',
    then: Yup.string(),
    otherwise: Yup.string().required('Bank Name is required'),
  }),
  branchName: Yup.string().when('accountType', {
    // .when('transferType', {
    is: 'IAT',
    then: Yup.string(),
    otherwise: config.BENE_BRANCH && Yup.string().required('Branch Name is required'),
  }),
  bankCode: Yup.number(),
  // accountNumber: Yup.string()
  //   .min(13, 'Account No. should be 13 digits')
  //   .required('Account No. is required'),

  accountNumber: Yup.string().when('accountType', {
    is: 'IAT',
    then: Yup.string()
    // .min(13, i18n.t(VALIDATION.ACCOUNTNOVALID))
      .matches(new RegExp(config.ACC_NO_VALIDATION), i18n.t(VALIDATION.REGACCOUNTNOVALID))
      .required(i18n.t(VALIDATION.ACCOUNTNO)),
    otherwise: Yup.string()
      .min(5, i18n.t(VALIDATION.ACCOUNTNOVALID1))
      .max(20, i18n.t(VALIDATION.ACCOUNTNOVALID1))
      .required(i18n.t(VALIDATION.ACCOUNTNO)),
  }),

  confirmAccountNumber: Yup.string()
    .oneOf([Yup.ref('accountNumber'), null], i18n.t(VALIDATION.CONFIRMACCOUNTNUMBERVALID))
    .required(i18n.t(VALIDATION.CONFIRMACCOUNTNUMBER)),
  amount: Yup.string()
    // .matches(new RegExp('^[red1-9][0-9]*$'), 'Instant transfer should not start with 0')
    .required(i18n.t(VALIDATION.AMOUNT)),
  remarks: Yup.string().min(4, 'Minimuim 4 Characters').required(i18n.t(VALIDATION.REMARKS)),
  beneficiaryName: Yup.string().when('accountType', {
    // .when('transferType', {
    is: 'IAT',
    then: Yup.string(),
    otherwise: Yup.string()
      .required(i18n.t(VALIDATION.BENEFICIARYNAME))
      .min(2, i18n.t(VALIDATION.BENEFICIARYNAMEVALID))
      .max(32, i18n.t(VALIDATION.BENEFICIARYNAMEVALID)),
  }),
  bank: Yup.string(),
  branch: Yup.string(),
  customRemarks: Yup.string().when('remarks', {
    is: 'Custom',
    then: Yup.string().required(i18n.t(VALIDATION.CUSTOMTREMARK)),
    otherwise: Yup.string().optional(),
  }),
})
